import { LOGG_UT_ARSAK } from './constants';
import type { InaktivitetsResponseType, ModalTeksterType } from './types';

let cultureSuffix = document.documentElement.getAttribute('lang') ?? 'nb-no';

export async function kallSjekkOmSesjonUtloper({
  grunnetInaktivitet,
  bekreft,
}: {
  grunnetInaktivitet: boolean;
  bekreft: boolean;
}) {
  const res = await fetch(`/du/SjekkOmSesjonUtloper?bekreftInaktivEllerUtloper=${bekreft}`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
  if (res.status === 401) {
    const params = new URLSearchParams(window.location.search);
    // Hindrer at vi navigerer til logget_ut dersom vi allerede er der eller på DS sitt feilside
    if (
      params.get('status') === 'logget-ut' ||
      document.querySelector('meta[name="test"]')?.getAttribute('value') === 'Feil'
    ) {
      throw new Error('logget ut');
    }
    cultureSuffix = document.documentElement.getAttribute('lang') ?? 'nb-no';
    window.location.replace(
      `/${cultureSuffix}/innlogging?status=logget-ut&arsak=${grunnetInaktivitet ? LOGG_UT_ARSAK.Inaktivitet : LOGG_UT_ARSAK.SesjonUtlopt}`,
    );
    throw new Error('Unauthorized');
  } else if (!res.ok) {
    throw new Error('Noe feilet');
  }
  return res.json() as Promise<InaktivitetsResponseType>;
}

export function refreshSession() {
  return fetch('/du/UtvidSesjon', {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
}

export async function hentTekster(): Promise<ModalTeksterType> {
  const params = new URLSearchParams({
    culture: cultureSuffix,
  });
  const res = await fetch(`/api/mt1534/CMSProxy/lkno/InaktivitetsModal?${params}`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
  return res.json();
}
